export default __webpack_public_path__ + "static/media/deauville08.61c0b30a.jpg";